import React from "react";

type Props = {};

const Footer: React.FC<Props> = () => {
  return (
    <footer className="footer footer-alt">
      2025 - <script>document.write(new Date().getFullYear())</script> © ARCUS
    </footer>
  );
};

export default Footer;
